import React from "react";
import "./ErrorModal.css";
import img from '../../assets/error.png'

const ErrorModal = ({ onClose, message }) => {
    return (
        <div className="error-modal-overlay">
            <div className="error-modal-content">
                <img src={img} alt="error" className="error-modal-image" />
                <p>{message}</p>
                <button className="error-modal-button error" onClick={onClose}>
                    Kapat
                </button>
            </div>
        </div>
    );
};

export default ErrorModal;
